import {ConfigsProperties} from './index'

const config: ConfigsProperties = {
    BASE_API: 'http://180.168.126.92:8080/',
    SHA1_SALT: '6sJJnUiq',
    QINIU_HOST: 'http://cdn-srm-test.xmiws.com/',
    MINIO_HOST: 'http://180.168.126.92:9000/fosun/',
    ENV_NAME: 'UAT环境'
}

export default config
